<template>
<div class="chapter">
<div class="inner_page">
<p class="halftitle"><a id="page_i"></a><a id="halftitle"></a>HOW TO<br/>GET IDEAS</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// halftitle.vue?27ebb3dd